import Coin_Icon from '@assets/svg/coin.svg';
import { useEffect, useState } from 'react';
import { ProgressBar, Reward, RewardIcon, RewardName, RewardProgress, RewardStats } from './RewardItem.styled';
import Badges from '@models/Badges';
import { Comeback_kid } from '@models/BadgesAnimation';
import { useStore } from '@store/appStore';
import { useI18n } from '@i18n/useI18n';
import Rewards from '@models/Rewards';
import db from '@utils/db';

interface IProps {
  rewardItem?: any;
  profileCoins?: number;
  studentId?: any;
  isAdmin?: boolean;
}

const RewardItem = (props: IProps) => {
  const [progress, setProgress] = useState(0);
  const { setBadge, setRewardPreview, systemSettings } = useStore();
  const i18n = useI18n();
  let language = systemSettings.find((s) => s.APP_Setting_ID === 16);
  useEffect(() => {
    if (props.rewardItem) {
      setProgress(props.rewardItem.cost === 0 ? 100 : (props.profileCoins / props.rewardItem.cost) * 100);
    }
  }, [props.profileCoins]);

  const showReward = async (r) => {
    let rewards = (await db.Student_Stat_GetRewards(props.studentId, language.value)) ?? [];
    let reward = rewards.find((reward) => reward.id === r.id);
    setBadge({
      id: reward.id,
      username: props.studentId,
      title: reward.title,
      description: reward.description,
      badgeImage: Rewards[reward.icon].icon,
      cost: reward.cost,
      stock:
        reward.initial_stock === -1
          ? -1
          : reward.initial_stock - reward.total_purchased_count - reward.reserved_count < 0
          ? 0
          : reward.initial_stock - reward.total_purchased_count - reward.reserved_count,
      limit: reward.limit_pr_user,
      purchased: reward.student_purchased_count,
    });
    setRewardPreview(true);
  };

  let Icon = Rewards[props.rewardItem.icon].icon;

  return (
    <Reward admin={props.isAdmin} onClick={() => (props.isAdmin ? null : showReward(props.rewardItem))}>
      <RewardStats>
        <span>
          {props.rewardItem.cost} <Coin_Icon />
        </span>
        <span>
          {props.rewardItem.limit_pr_user !== -1 && props.rewardItem.student_purchased_count >= props.rewardItem.limit_pr_user
            ? 0
            : props.rewardItem.initial_stock === -1
            ? null
            : props.rewardItem.initial_stock - props.rewardItem.total_purchased_count - props.rewardItem.reserved_count < 0
            ? 0
            : props.rewardItem.initial_stock - props.rewardItem.total_purchased_count - props.rewardItem.reserved_count}{' '}
          {props.rewardItem.initial_stock === -1 ? null : i18n.t('reward-left')}
        </span>
      </RewardStats>
      <RewardIcon progress={progress >= 100}>{<Icon />}</RewardIcon>
      <RewardProgress>
        <ProgressBar progress={progress} />
      </RewardProgress>
      <RewardName>
        <p>{i18n.t(props.rewardItem.title)}</p>
      </RewardName>
    </Reward>
  );
};

export default RewardItem;
